<app-loading-overlay></app-loading-overlay>
<ng-container *ngIf="activeURL$ | async as activeUrl" class="iframe-container">
  <app-i-frame-loader [activeUrl]="activeUrl"></app-i-frame-loader>
</ng-container>
